import styled from "styled-components";

export const LoadingContainer = styled.div(({ theme }) => ({
    margin: `calc(3 * ${theme.spacing.xxLarge}) 0`,
    height: "100%",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));
